
import { Component, Vue } from 'vue-property-decorator'
import GoodsResultCard from "@/views/goodsManage/mall/shop/template/GoodsResultCard.vue";
import { batchDeleteFavorite, getFavoriteGoodsList } from "@/api/shoppingMall"
import { goodsDto } from '@/api/goods'
import { Getter } from "vuex-class";

@Component({
  name: 'Favorites',
  components: { GoodsResultCard }
})
export default class Favorites extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string

  result = []
  isEdit = false
  favoriteList: Array<goodsDto> = []
  params = {
    pageIndex: 1,
    pageSize: 10,
    companyId: "hm001",
    shopId: "h001"
  }
  refreshing = false
  loading = false
  finished = false

  created () {
    this.params.companyId = this.companyId
    this.params.shopId = this.providerId
    this.getFavoriteList()
  }

  getFavoriteList () {
    getFavoriteGoodsList(this.params).then(res => {
      this.refreshing = false
      this.favoriteList = res.data.records || []
      if (this.favoriteList.length >= res.data.totalRecords) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getFavoriteList()
  }

  /**
   * 上拉加载更多
   * */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    getFavoriteGoodsList(this.params).then(res => {
      this.favoriteList = this.favoriteList.concat(res.data.records)
      this.loading = false;
      if (this.favoriteList.length >= res.data.totalRecords) {
        this.finished = true;
      }
    })
  }

  reloadList () {
    this.params.pageIndex = 1
    this.getFavoriteList()
  }

  handleFunc () {
    this.isEdit = !this.isEdit
    // this.isEdit ? (this.$refs.container as any).classList.add('edit-list') : (this.$refs.container as any).classList.remove('edit-list')
  }

  /**
   * 移除收藏夹
   */
  removeFavorite () {
    if (this.result && this.result.length > 0) {
      this.$confirmDialog.show({
        okText: "确认",
        cancelText: "取消",
        tips: "确认要移出收藏夹吗?",
        onOk: () => {
          return this.delFunc()
        },
      });
    } else {
      this.$toast('请先选择商品')
    }


  }

  delFunc () {
    const params = {
      companyId: this.companyId,
      shopId: this.providerId,
      goodsIdList: this.result.map(item => {
        return { goodsId: item }
      })
    }
    batchDeleteFavorite(params).then(() => {
      this.$toast.success('移出成功')
      // 修复
      this.result = []
      this.isEdit = false
      this.getFavoriteList()
    }).catch(() => { })
  }

  toBuyCar () {
    this.$router.push('/buyCar')
  }
}
